import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, Estado, SearchEstadoRequest, SearchEstadoResponse, SaveEstadoDto, TipoEstado } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class EstadoService extends CrudService<Estado, number, SaveEstadoDto, SearchEstadoRequest> {
  
  
  
  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'estado', sharedFunctions);

  }

  getTipos(): Observable<GenericResponse<TipoEstado[]>> {
    return this._http.get<GenericResponse<TipoEstado[]>>(this._serviceUrl + '/tipos', this.httpOptions);
  }

  searchUsuarioEstados(p: SearchEstadoRequest): Observable<SearchEstadoResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchEstadoResponse>(this._serviceUrl + '/search-usuario'+parameters, this.httpOptions);
  }

  searchIncidenciaEstados(p: SearchEstadoRequest): Observable<SearchEstadoResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchEstadoResponse>(this._serviceUrl + '/search-incidencia'+parameters, this.httpOptions);
  }

  searchPedidoEstados(p: SearchEstadoRequest): Observable<SearchEstadoResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchEstadoResponse>(this._serviceUrl + '/search-pedido'+parameters, this.httpOptions);
  }

  searchMovimientoEstados(p: SearchEstadoRequest): Observable<SearchEstadoResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchEstadoResponse>(this._serviceUrl + '/search-movimiento'+parameters, this.httpOptions);
  }

  searchExpensaEstados(p: SearchEstadoRequest): Observable<SearchEstadoResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchEstadoResponse>(this._serviceUrl + '/search-expensa'+parameters, this.httpOptions);
  }
}